module.exports = __webpack_public_path__ + "assets/adpoly-it-cctv-bulk-upload-template.46935432.xlsx";